import { render, staticRenderFns } from "./VotersGuide.vue?vue&type=template&id=52caeaff"
import script from "./VotersGuide.vue?vue&type=script&lang=js"
export * from "./VotersGuide.vue?vue&type=script&lang=js"
import style0 from "./VotersGuide.vue?vue&type=style&index=0&id=52caeaff&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports